(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guau-noel-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(r) {
    if (r.dataset.gnReady) { return; }
    r.dataset.gnReady = '1';
    r.classList.add('gn-js');
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var n = parseInt(r.dataset.snow, 10) || 0;
    var s = r.querySelector('.gn-snow');
    if (s && n > 0 && !rm) {
      for (var i = 0; i !== n; i++) {
        var f = document.createElement('i');
        var z = 2 + Math.random() * 3;
        f.style.left = (Math.random() * 100) + '%';
        f.style.width = z + 'px';
        f.style.height = z + 'px';
        f.style.opacity = String(0.35 + Math.random() * 0.5);
        f.style.animationDuration = (9 + Math.random() * 9) + 's';
        f.style.animationDelay = '-' + (Math.random() * 14) + 's';
        s.appendChild(f);
      }
    }
    var els = r.querySelectorAll('.gn-rv');
    function show(e) { e.classList.add('gn-in'); }
    if (rm || !('IntersectionObserver' in window)) {
      els.forEach(show);
    } else {
      var io = new IntersectionObserver(function (list) {
        list.forEach(function (x) {
          if (x.isIntersecting) { show(x.target); io.unobserve(x.target); }
        });
      }, { threshold: 0.12 });
      els.forEach(function (e) { io.observe(e); });
    }
    r.querySelectorAll('form.gn-add').forEach(function (f) {
      var b = f.querySelector('button');
      var m = f.querySelector('.gn-msg');
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (b.disabled) { return; }
        b.disabled = true;
        b.dataset.s = 'load';
        m.textContent = 'Añadiendo…';
        fetch(f.action + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [ { id: Number(f.dataset.id), quantity: 1 } ] })
        })
        .then(function (res) {
          return res.json().then(function (d) {
            if (!res.ok) { throw new Error(d.description || d.message || ''); }
            return d;
          });
        })
        .then(function () {
          b.dataset.s = 'ok';
          b.textContent = 'Añadido';
          m.textContent = 'Listo. ';
          var a = document.createElement('a');
          a.href = f.dataset.cart;
          a.textContent = 'Ver carrito';
          m.appendChild(a);
          setTimeout(function () {
            b.disabled = false;
            b.dataset.s = '';
            b.textContent = 'Añadir al carrito';
          }, 2500);
        })
        .catch(function (e) {
          b.dataset.s = 'err';
          b.disabled = false;
          b.textContent = 'Reintentar';
          m.textContent = e.message || 'No se pudo añadir. Inténtalo de nuevo.';
        });
      });
    });
  }
  function boot() { document.querySelectorAll('.gn-home').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
